export const SUBMITTED_WARNING_MESSAGE = "You’ve previously submitted information for this question. For your privacy, your response is not displayed. You may update your response below if needed.";
